import { authenticatedApiCall } from './keycloak-auth';

export interface CreateOpportunityRequest {
  name: string;
  website?: string | undefined;
  phone?: string | undefined;
  fax?: string | undefined;
  address?: string | undefined;
  zipCode?: string | undefined;
  language?: string | undefined;
  originationSource?: string | undefined;
  companyType: 'Prospect' | 'Customer' | 'Partner' | 'Vendor';
  status: 'Initial' | 'Qualified' | 'In Progress' | 'Negotiation' | 'Closed Won' | 'Closed Lost';
  priority: 'Low' | 'Medium' | 'High' | 'Urgent';
}

export interface CreateOpportunityResponse {
  success: boolean;
  message: string;
  data: {
    party_id: string;
    address_id?: string;
    phone_numbers_created: number;
  };
}

export interface GetOpportunitiesParams {
  page?: number | undefined;
  limit?: number | undefined;
  search?: string | undefined;
  status?: string[] | undefined;
  priority?: string[] | undefined;
  sortBy?: string | undefined;
  sortOrder?: 'asc' | 'desc' | undefined;
}

export interface OpportunityListItem {
  id: string;
  name: string;
  status: string;
  priority: string;
  createdAt: string;
  lastContact?: string | undefined;
  salesStage: string;
  contactCount: number;
  website?: string | undefined;
  address?: string | undefined;
  city?: string | undefined;
  postalCode?: string | undefined;
  stateProvinceCode?: string | undefined;
  countryCode?: string | undefined;
}

export interface GetOpportunitiesResponse {
  success: boolean;
  data: OpportunityListItem[];
  pagination: {
    page: number;
    pageSize: number;
    total: number;
    totalPages: number;
  };
}

/**
 * Get all opportunities with pagination and filtering
 */
export async function getOpportunities(
  params: GetOpportunitiesParams = {}
): Promise<GetOpportunitiesResponse> {
  const searchParams = new URLSearchParams();

  if (params.page) searchParams.set('page', params.page.toString());
  if (params.limit) searchParams.set('limit', params.limit.toString());
  if (params.search) searchParams.set('search', params.search);
  if (params.sortBy) searchParams.set('sortBy', params.sortBy);
  if (params.sortOrder) searchParams.set('sortOrder', params.sortOrder);
  if (params.status?.length) searchParams.set('status', params.status.join(','));
  if (params.priority?.length) searchParams.set('priority', params.priority.join(','));

  const queryString = searchParams.toString();
  const url = `/opportunities${queryString ? `?${queryString}` : ''}`;

  return authenticatedApiCall<GetOpportunitiesResponse>(url, {
    method: 'GET',
  });
}

/**
 * Create a new opportunity
 */
export async function createOpportunity(
  data: CreateOpportunityRequest
): Promise<CreateOpportunityResponse> {
  return authenticatedApiCall<CreateOpportunityResponse>('/opportunities', {
    method: 'POST',
    body: JSON.stringify(data),
  });
}
